import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbDialogRef, NbButtonModule, NbCardModule } from '@nebular/theme';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-image-preview-dialog',
  templateUrl: './image-preview-dialog.component.html',
  styleUrls: ['./image-preview-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NbButtonModule,
    NbCardModule,
    FontAwesomeModule,
    TranslateModule
  ]
})
export class ImagePreviewDialogComponent {
  public imageUrl: string;
  public imageAlt: string;
  public imageTitle: string;
  public imageError = false;

  constructor(
    @Inject(NbDialogRef) protected dialogRef: NbDialogRef<ImagePreviewDialogComponent>
  ) {
    const context = (this.dialogRef as any).context || {};
    this.imageUrl = context.imageUrl || '';
    this.imageAlt = context.imageAlt || '';
    this.imageTitle = context.imageTitle || '';
  }

  public downloadImage(): void {
    if (!this.imageUrl) return;

    fetch(this.imageUrl)
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = this.imageTitle || 'image';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch(error => {
        console.error('Failed to download image:', error);
        window.open(this.imageUrl, '_blank');
      });
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public onImageError(_event: any): void {
    this.imageError = true;
  }
}
